import React from 'react';
import { RootLayout } from '@src/layouts';
import { AdminRoutes, AnalystRoutes, OperatorRoutes, ViewerRoutes } from './routes';
import { withRootInitialize } from './hocs';
import { RootProps } from './types';
import { AdminProviders, AnalystProviders } from './providers';
import { UserRoleType } from '@src/core/features';


const Root: React.FC<RootProps> = ({ userData }) => {
  const role = userData?.role;

  if (role === UserRoleType.ADMIN || role === UserRoleType.SUPERADMIN || role === UserRoleType.OWNER) {
    return (
      <AdminProviders>
        <RootLayout>
          <AdminRoutes />
        </RootLayout>
      </AdminProviders>
    );
  }

  if (role === UserRoleType.VIEWER)
    return (
      <AdminProviders>
        <RootLayout>
          <ViewerRoutes />
        </RootLayout>
      </AdminProviders>
    );

  if (role === UserRoleType.OPERATOR) {
    return (
      <AdminProviders>
        <RootLayout>
          <OperatorRoutes />
        </RootLayout>
      </AdminProviders>
    );
  }

  if (role === UserRoleType.ANALYST) {
    return (
      <AnalystProviders>
        <RootLayout>
          <AnalystRoutes />
        </RootLayout>
      </AnalystProviders>
    );
  }

  return null;
};

export default withRootInitialize(Root);